module.exports = __webpack_public_path__ + "static/media/warehouse-list.7b27478e.svg";